import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { CalculatorIconType } from "shared/CalculatorIcons";
import type { QuickCalculatorVariant } from "web_myplann/Dashboard/Components/quickCalculators";
import { CalculatorIcon } from "web_myplann/Shared/Components/CalculatorIcon";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	type: CalculatorIconType;
	label: string;
	variant: QuickCalculatorVariant;
	onClick: () => void;
};

export const QuickCalculatorTile: FC<Props> = ({
	type,
	label,
	variant,
	onClick,
}) => {
	const theme = useTheme();
	const tint = theme.dashboard.quickCalculator.tints[variant];

	return (
		<Stack
			component="button"
			onClick={onClick}
			alignItems="center"
			flexShrink={0}
			width={64}
			border="none"
			p={0}
			sx={{
				background: "transparent",
				cursor: "pointer",
				"&:active": { transform: "scale(0.95)" },
			}}
		>
			<IconBox bg={tint.background} shape="circle" size={56}>
				<CalculatorIcon type={type} color={tint.icon} size={28} />
			</IconBox>
			<Typography
				variant="button"
				color="text.secondary"
				display="block"
				pt={1}
				textAlign="center"
				lineHeight={1.25}
			>
				{label}
			</Typography>
		</Stack>
	);
};
